import React, { useCallback, useEffect, useState } from "react";
import { Toolbar, Typography } from "@mui/material";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import TableRowsLoader from "../../../components/common/Loader/tableLoader";
import { ClientReportType } from "../../../types/genericType";
import { getClientReportDetails } from "../../../services/clientService";
import ClientsReportTable from "../../../components/clientsReportTable/ClientsReportTable";
import "./styles.scss";
import useFileDownloader from "../../../hooks/useFileDownloader";
import { apiEndPoints } from "../../../variables/apiEndpoints";
import CustomSnackbar from "../../../components/common/Snackbar/CustomSnackbar";
import { LoadingButton } from "@mui/lab";


const ClientReport = () => {
  const { downloadFile } = useFileDownloader();
  const [clientsData, setClientsData] = useState<ClientReportType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>([]);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  const getClientsData = () => {
    setIsLoading(true);
    getClientReportDetails()
      .then((res) => {
        setIsLoading(false);
        const dataWithIds = res.map((client, index) => ({
          ...client,
          clientId: `client-${index}` 
        }));
        setClientsData(dataWithIds);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getClientsData();
  }, []);

  const handleDownload = useCallback(async () => {
    setIsDownloading(true);
    
    // Extract account numbers from selected rows
    const selectedAccountNumbers = rowSelectionModel
      .map((selectedId) => {
        const client = clientsData.find((client) => client.clientId === selectedId);
        return client?.accountNumber;
      })
      .filter((accountNumber): accountNumber is string => accountNumber !== undefined);
    
    const result = await downloadFile({
      url: `/reports${apiEndPoints.clientDetails}`,
      method: "post",
      fileName: "ClientDetails.csv",
      data:
        selectedAccountNumbers.length > 0
          ? { accountNumbers: selectedAccountNumbers }
          : {},
    });
    
    setIsDownloading(false);

    if (!result.success) {
      setSnackbarMsg(result.errorMessage || "Error downloading file");
      setOnSuccess(true);
    }
  }, [downloadFile, rowSelectionModel, clientsData]);

  return (
    <>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography className="title">Client Report</Typography>
        <LoadingButton
          variant="contained"
          color="primary"
          data-testid="exportBtn"
          className="export-button"
          onClick={handleDownload}
          loading={isDownloading || isLoading}
        >
          Create Report
        </LoadingButton>

      </Toolbar>
      {!isLoading ? (
        <ClientsReportTable
          data={clientsData}
          rowSelectionModel={rowSelectionModel}
          setRowSelectionModel={setRowSelectionModel}
        />
      ) : (
        <TableRowsLoader rowsNum={10} />
      )}
      <CustomSnackbar
        open={onSuccess}
        message={snackbarMsg}
        setOpen={setOnSuccess}
      />
    </>
  );
};

export default ClientReport;
